import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { ConfirmEventType, ConfirmationService } from 'primeng/api';
import { MsPermissionService } from 'src/app/services/ms-permission.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']

})
export class ProjectListComponent {

  @Input() title: string = "";
  @Input() activeIndex: number = 0;
  @Input() projects: any[] = [];
  @Output() projectDeleted: EventEmitter<void> = new EventEmitter<void>();
  MsPermissionService = MsPermissionService;

  projectStatus: any[] = [
    { name: "Weights" },
    { name: "Criteria" },
    { name: "Enquiries" },
    { name: "Calendar" },
    { name: "Evaluation" }
  ];

  //Permissions
  uid: string = localStorage.getItem('uid') ?? '';
  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }


  ngOnInit() {
    this.projects = this.MsPermissionService.setProjectPermissions(this.projects);
  }

  extractUsername(name: any) {
    if (name) {
      return name.first + ' ' + name.middle + ' ' + name.last;
    }
    return ''
  }

  canShowDashboard(responsibles: any[]) {
    let res = responsibles?.find(r => r.user == this.uid);
    if (!res) {
      return false;
    }
    return res.isSenior;
  }

  canShowFactorStatus(responsibles: any[]) {
    let res = responsibles?.find(r => r.user == this.uid);
    if (!res) {
      return false;
    }
    return !res.isSenior;
  }

  canShowEvaluation(steps: any[]) {
    if (steps) {
      console.log("Steps -----", steps);
      let evaluationEnabled = false;
      let allStepsApproved = true;
      this.projectStatus.forEach((projectStep: any) => {
        const matchedStep = steps.find((step: any) => step._id == projectStep.name);
        if (matchedStep) {
          if (matchedStep.approvalStatus !== 'Approved') {
            allStepsApproved = false;
          }
          else {
            allStepsApproved = false;
          }
        }
        let stepsToCheck = this.projectStatus.slice(0, this.projectStatus.length - 1);
        evaluationEnabled = stepsToCheck.every(step => step.status === 'Approved');

        console.log("evaluationEnabled", evaluationEnabled);
      });
      return evaluationEnabled;
    }
    else {
      return false
    }
  }

  isVendor(project: any) {
    return project.role == "vendor"
  }

  isPm(project: any) {
    return project.role == "pm"
  }

  confirmDelete(id: string) {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => {
        this.deleteProject(id);
      },
    });
  }

  async deleteProject(id: string) {
    try {
      let res = await this.dataService.deleteData(`ms-project/${id}`)
      if (res.error) {
        console.log(res.error);
        return;
      }
      this.projectDeleted.emit();
    } catch (e) {
      console.log(e);
    }
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

}
